import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferBadge: Partial<Record<OfferKindEnum, string>> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: 'Extra {{percentageAmount}}% korting',
  [OfferKindEnum.PercentageOffByProducts]: 'Extra {{percentageAmount}}% korting',
  [OfferKindEnum.AmountOffByProducts]: 'Extra {{amount}} korting',
  [OfferKindEnum.Bogo]: '2 VOOR 1',
  [OfferKindEnum.BogoHalfPrice]: 'Koop 1, krijg 1 voor halve prijs!',
  [OfferKindEnum.FreeItemByProducts]: 'Gratis artikel',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Gratis artikel',
};

export default OfferBadge;
